import React from 'react';
import {Box, Flex, Container, Heading, Image, Text, Center, Highlight} from "@chakra-ui/react";
import {HiOutlineArrowNarrowLeft, HiOutlineArrowNarrowRight} from "react-icons/hi"
import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import {Navigation, EffectFade} from "swiper";
const OurCompetencies = ({heading, highlight, text, span, headingTwo, staticData, bg, radius, p, padding}) => {
    return (
        <Box>
            <Container mb="84px" maxW="container.xl" p={{base:"0",md:"4"}}>
                <Flex alignItems="center" w="full" bg={bg} borderRadius={radius} p={p}
                      flexDir={{base: "column", lg: "row"}}>
                    <Box p={padding} w={{base: "full", lg: "50%"}} mb={{base: "20px", lg: "0"}}
                         mr={{base: "0", lg: "78px"}}>
                        <Heading pb={{base: "10px", lg: "4px"}} fontFamily='Raleway' fontWeight="700"
                                 fontSize={{base: "30px", md: "54px"}} color="#111212"
                                 lineHeight={{base: "35px", md: "63px"}}>
                            <Highlight query={highlight} styles={{color: "#E92F34"}}>{heading}</Highlight>
                        </Heading>
                        <Text fontFamily='Raleway' fontWeight="400" fontSize={{base: "18px", md: "24px"}}
                              color="#000000"
                              lineHeight={{base: "21px", md: "28px"}}>{text}</Text>
                    </Box>
                    <Box w={{base: "full", lg: "45%"}} bg="#FFFFFF" border="1px solid #E9ECED" borderRadius="24px"
                         boxShadow="0px 2px 4px rgba(148, 165, 168, 0.25)">
                        <Box p={{base: "38px 12px", lg: "38px 16px"}}>
                            <Heading pb="8px" fontFamily='Raleway' fontWeight="700"
                                     fontSize={{base: "18px", md: "24px"}}
                                     color="#000000" lineHeight={{base: "21px", md: "28px"}}>{headingTwo}</Heading>
                            <Text fontFamily='Raleway' fontWeight="400" fontSize={{base: "16px", md: "18px"}}
                                  color="#000000" lineHeight={{base: "19px", md: "21px"}}>{span}</Text></Box>
                        <Box className="ourCompetencies" w="full" px={{base: "12px", lg: "16px"}} pb={{base: "14px", lg: "21px"}}>
                            <Swiper
                                navigation={{
                                    prevEl: '#mySwiper.swiper-button-prev',
                                    nextEl: '#mySwiper.swiper-button-next'
                                }}
                                modules={[Navigation, EffectFade]}
                                className="mySwiper"
                            >
                                {staticData.map(({img}) => (
                                    <SwiperSlide ><Image w="full" h="280px" borderRadius="20px" src={img} alt="img"/></SwiperSlide>
                                ))}
                                <Center fontSize="25px" color="#394A6C" id="mySwiper"
                                        className="swiper-button-prev"><HiOutlineArrowNarrowLeft/></Center>
                                <Center fontSize="25px" color="#394A6C" id="mySwiper"
                                        className="swiper-button-next"><HiOutlineArrowNarrowRight/></Center>
                            </Swiper>
                        </Box>
                    </Box>
                </Flex>
            </Container>
        </Box>
    );
};

export default OurCompetencies;